import { useEffect } from "react";

const BASE = "https://www.fatturazionegestionale.com";
const meta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

export const useSeo = (title, description, path) => {
  useEffect(() => {
    const prev = document.title;
    const prevDesc = document.head.querySelector("meta[name=description]")?.getAttribute("content") || "";
    document.title = `${title} | FatturazioneGestionale`;
    meta("name", "description", description);
    meta("property", "og:title", document.title);
    meta("property", "og:description", description);
    meta("property", "og:url", `${BASE}${path}`);
    let link = document.head.querySelector("link[rel=canonical]");
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = `${BASE}${path}`;
    return () => { document.title = prev; meta("name", "description", prevDesc); link.href = `${BASE}/`; meta("property", "og:url", `${BASE}/`); };
  }, [title, description, path]);
};
